import { useMemo } from 'react'
import { useFirebaseQuery } from '../hooks/firebaseHooks'
import { COLLECTIONS, PLAN_DEAL_LIMITS, PLAN_NAMES, PlanId } from '../utils/shared/constants'
import { orderBy } from 'firebase/firestore'
import PageHeader from '../components/PageHeader'
import { DataTable } from '../components/DataTable'
import { User } from '../models/shared/User'
import { Organization } from '../models/shared/Organization'
import { formatDate } from '../utils/date'
import { AdvancedButton } from '../components/AdvancedButton'
import { PATHS } from '../utils/shared/constants'

export default function SuperAdminPage() {
    const [users] = useFirebaseQuery<User>(COLLECTIONS.USERS, orderBy('lastSeenAt', 'desc'))
    const [organizations] = useFirebaseQuery<Organization>(COLLECTIONS.ORGANIZATIONS)

    const orgByOwnerUid = useMemo(() => {
        const map: Record<string, Organization> = {};
        for (const org of organizations) {
            map[org.ownedBy] = org;
        }
        return map;
    }, [organizations]);

    return (
        <>
            <PageHeader title='Super Admin' />

            <h4>Users</h4>
            <DataTable
                data={users}
                columns={[
                    { key: 'email', label: 'Email' },
                    { label: 'Last Seen At', render: (user: User) => formatDate(user.lastSeenAt) },
                    {
                        label: 'Organization',
                        render: (user: User) => orgByOwnerUid[user.uid]?.name || '—'
                    },
                    {
                        label: 'Plan',
                        render: (user: User) => {
                            const org = orgByOwnerUid[user.uid];
                            if (!org) return '—';
                            const planId: PlanId = org.billing?.planId || 'free';
                            const limit = PLAN_DEAL_LIMITS[planId];
                            const limitLabel = limit === -1 ? '∞' : String(limit);
                            return `${PLAN_NAMES[planId]} (${limitLabel})`;
                        }
                    },
                    {
                        label: '',
                        align: 'right',
                        render: (user: User) => (
                            <AdvancedButton
                                size='sm'
                                variant='outline-secondary'
                                icon='bi-arrow-right'
                                link={`${PATHS.SUPER_ADMIN}/${user.uid}`}
                            />
                        )
                    }
                ]}
            />
        </>
    )
}
